import { useInhibitKeyPressOverride } from '@hooks/useInhibitKeyPressOverride'
import { useWeekDates } from '@hooks/useWeekDates'
import { useWeekScope } from '@hooks/useWeekScope'
import { WeekSelector as WeekSelectorComponent } from 'components/navigation'
import { FC } from 'react'

const MENU_ID = 'week-selector'

export const WeekSelector: FC = () => {
  const { weekStartsOn } = useWeekScope()
  const { start, set: selectWeek } = useWeekDates({ weekStartsOn })
  const { registerMenuClosed, registerMenuOpened } =
    useInhibitKeyPressOverride()

  return (
    <WeekSelectorComponent
      onMenuHiddenChange={(hidden) =>
        hidden ? registerMenuClosed(MENU_ID) : registerMenuOpened(MENU_ID)
      }
      onWeekSelect={selectWeek}
      selectedWeek={start}
      weekStartsOn={weekStartsOn}
      hideWeekStartsOnSelector
    />
  )
}
